export const environment = {
  production: false,
  apiHost: 'https://demo-apimanager.trustage.com/finpro_compapi/v1/',
};
// Demo environment
